import { useEffect } from "react";
import {
  checkIfContainsTargeted,
  checkIfSelectorMatchTargeted,
  setClickStreamSearchSource,
} from "../helpers/clickStreamHelpers";

export default function useClickStreamSourceSetter(
  selectorsAndSearchSourceMap,
  handleSpecialCases
) {
  function addClickStreamSearchSource(e) {
    let target = e.target as HTMLElement;
    for (const [
      selector,
      searchSource,
    ] of selectorsAndSearchSourceMap.entries()) {
      if (
        checkIfSelectorMatchTargeted("class", target, selector) ||
        checkIfSelectorMatchTargeted("id", target, selector) ||
        checkIfContainsTargeted(target, selector)
      ) {
        const specialCaseSource = handleSpecialCases(selector);
        setClickStreamSearchSource(
          specialCaseSource ? specialCaseSource : searchSource
        );
      }
    }
  }

  useEffect(() => {
    document.addEventListener("click", addClickStreamSearchSource);
    return () =>
      document.removeEventListener("click", addClickStreamSearchSource);
  }, []);
}
